export function getAvailableYears(geojson) {
  if (!geojson || !geojson.features || geojson.features.length === 0) {
    return [];
  }

  const firstFeature = geojson.features[0];
  if (!firstFeature.feature_data_simple_timeseries) {
    return [];
  }

  // Get the first timeseries object inside feature_data_simple_timeseries
  const firstTimeseriesKey = Object.keys(firstFeature.feature_data_simple_timeseries)[0];
  const firstTimeseries = firstFeature.feature_data_simple_timeseries[firstTimeseriesKey];

  if (!firstTimeseries || typeof firstTimeseries !== "object") {
    return [];
  }

  // Extract and sort the years
  const years = Object.keys(firstTimeseries).sort((a, b) => new Date(a) - new Date(b));

  return years;
}